export default "__VITE_ASSET__f7d7a140__"